import { render, staticRenderFns } from "./flats-crm-items-list.vue?vue&type=template&id=a3a5d082&"
import script from "./flats-crm-items-list.vue?vue&type=script&lang=js&"
export * from "./flats-crm-items-list.vue?vue&type=script&lang=js&"
import style0 from "./flats-crm-items-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports